// extracted by mini-css-extract-plugin
module.exports = {"xt-btntxt":"index_xt-btntxt__hM_As","xtBtntxt":"index_xt-btntxt__hM_As"};